<div class="review position-relative">
  <div
    class="review__score position-absolute h4 d-flex justify-content-center align-items-center"
    [class.review__border]="showBorder"
  >
    {{ review.rating }}
  </div>
  <wl-composable-card [config]="cardConfig">
    <div class="p-2 border rounded">
      <div class="pb-2">
        <wl-review-stars [score]="review.rating"></wl-review-stars>
      </div>
      <div class="h4 review__title">
        {{ review.title }}
      </div>
      @if (review.wouldRecommend) {
        <div class="mb-2 text-brand fw-bold">
          <fa-icon icon="check"></fa-icon>
          <span> {{ 'RecommendsUs' | translate }}</span>
        </div>
      }
      <div
        #reviewText
        class="review__text"
        [class.review__text--expanded]="reviewTextExpanded"
      >
        {{ review.content }}
      </div>
      @if (reviewTextTruncated || reviewTextExpanded) {
        <button
          (click)="onExpand()"
          type="button"
          class="btn btn-link p-0 border-0 mt-1"
        >
          {{ reviewTextExpanded ? readLessButtonTitle : readMoreButtonTitle
          }}<fa-icon
            icon="chevron-down"
            [rotate]="reviewTextExpanded ? 180 : undefined"
            class="ms-1"
          />
        </button>
      }
      <div class="pt-2 fw-bold">
        {{ review.date | date: 'dd-MM-yyyy' }}
      </div>
      <div>
        <span>{{ review.author }}</span
        >,
        <span>{{ review.city }}</span>
      </div>
    </div>
  </wl-composable-card>
</div>
